export const xeroProTipLink =
    'https://support.approvalmax.com/portal/en/kb/articles/how-can-i-try-approvalmax-with-xero-demo-organisation';
